import React from 'react';
import { Link } from 'react-router-dom';
import  SimpleReactValidator from 'simple-react-validator';
import Preloader from '../../../core/Preloader';
import { viewData, processData } from '../../../core/HttpAction';
import {permissionCheck} from '../../../core/Permission';
import Nopermission from '../../../core/Nopermission';
const menuUrl='/getallmenu';
const Url='/roles';
const backUrl='/setting'+Url;
const actionsList={
    'View':'',
    'New':'',
    'Edit':'',
    'Delete':''};

class AddEditAction extends React.Component {
    constructor(props) {
        super(props); 
        this.state={
            loading: false,
            rolename:'',
            menus:[],
            description:'',
            error_status:false,
            preloader:this.props.match.params.id?true:false,
            title:this.props.match.params.id?'Edit':'New',
            status:1
        };
        this.validator = new SimpleReactValidator();
    }

    componentDidMount(){
 
        viewData(menuUrl).then((res)=>{
            if(res.data.status===200){
                let datam =res.data.data;
  
                if(this.props.match.params.id){
                    viewData(Url+'/'+this.props.match.params.id).then((res)=>{
                        if(res.data.status===200){
                            let data=res.data.data;
                            let tempData=[];
                            data.permission.map((val,i)=>{
                                tempData[val.pagename]=val.permission.split(',');
                            });

                            
  
                            let  temp = datam.map((val,i)=>{ 
                                let perarr=tempData[val.menuname]; 
                                let actionList=val.action_name.split(',');
                                if(perarr){
                                    var obj = {};
                                    perarr.map((val,i)=>{
                                        obj[val] = val;
                                    });
                                    return {
                                        pagename:val.menuname,
                                        actionList,
                                        ...obj,
                                    };
                                }else{
                                    return {pagename:val.menuname,
                                        actionList,
                                        ...actionsList
                                    };
                                }
                            }); 
  
                            this.setState({
                                rolename:data.rolename,
                                error_status:true,
                                description:data.description,
                                status:1,
                                preloader:false,
                                menus:temp
                            });
                        }
  
                    });
                }else{
                    let  temp = datam.map((val,i)=>{
                        let actionList=val.action_name.split(',');
                        return {
                            pagename:val.menuname,
                            actionList,
                            ...actionsList
                        };
                    }); 
                    this.setState({menus:temp,preloader:false});
                }
        
            }
  
        });
    }
 
 
    setStateFromInput=(event)=> {
        var obj = {};
        obj[event.target.name] = event.target.value;
        this.setState(obj);
    }

    submitForm=()=>{
        if( this.validator.allValid() ){
            let {rolename,description,status,menus} =this.state;
            let para=this.props.match.params.id?'/'+this.props.match.params.id:'';
            let params={
                rolename:rolename,
                description:description,
                menuval:menus,
                status:status
            };
            processData(Url+para,params).then((res)=>{
                if(res.data.status===200){
                    this.props.history.push(backUrl);
                } else{
                    const msg =res.data.message?res.data.message:'Please enter required feilds...';                     alert(msg);
                    this.setState({error_status:true,preloader:false});
                }
            });
        } else {
            this.validator.showMessages();
            this.forceUpdate();
        }
    }

    permissionSelect=(e,key,source)=>{ 
        this.state.menus[key][source]=this.state.menus[key][source]?'':source;
        this.setState({menus: this.state.menus});
    }
    
    render() {
        let {rolename,description,status,menus,title,preloader} = this.state;
      
        let role=permissionCheck('roles',title);
        if(!role)
            return <Nopermission/>;

        const rolenameValid= this.validator.message('name',rolename, 'required');
        const descriptionValid= this.validator.message('name',description, 'required');
        let permissionLopp = menus.map((val,i)=>{
            let actBtn= val.actionList;
            return<tr key={i}>
                <td> {val.pagename}</td>
                <td> 
                    {actBtn.map((value,m)=>{
                        return(
                            <span style={{width:'auto',top:'12px'}}  key={m} className="md-input-wrapper icheck-inline">
                                <span className=" md-checkbox"> 
                                    <input type="checkbox"onClick={(e)=>{
                                        this.permissionSelect(e,i,value) ;
                                    }} className="filled-in"  checked={val[value]} value={value}/>
                                    <label htmlFor="inline-checkbox1" className="inline-label" onClick={(e)=>{
                                        this.permissionSelect(e,i,value) ;
                                    }}>{value}</label>
                                </span>
                            </span>);
                    }) 
                    }
                </td>
            </tr>;
        });

        return (
            <div id="page_content_inner" className="uk-width-medium-7-10 uk-container-center">
                <h3 className="heading_b uk-margin-bottom">{title} Role</h3>
                <div className="md-card">
                    <div className="md-card-content large-padding">
                        <div className="uk-grid" data-uk-grid-margin>
                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${rolename ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="rolename">Role Name<span className="req">*</span></label>
                                    <input type="text" name="rolename" value={rolename} onChange={this.setStateFromInput} className={ `md-input ${rolenameValid ?'md-input-danger':''}`} /> 
                                    {rolenameValid} 
                                </div>
                            </div>

                            <div className="uk-width-medium-1-1"> 
                                <div className={ `md-input-wrapper ${description ? 'md-input-filled' : ''}`}>
                                    <label htmlFor="name">Description<span className="req">*</span></label>
                                    <input type="text" name="description" value={description} onChange={this.setStateFromInput} className={ `md-input ${descriptionValid ?'md-input-danger':''}`} /> 
                                    {descriptionValid} 
                                </div>
                            </div>
                            <div className="uk-width-medium-1-1">
                                <table>
                                    <thead>
                                        <tr>
                                            <th>Page Name</th>
                                            <th>Permisssion</th> 
                                        </tr>
                                    </thead>
                                    <tbody>
                                        { permissionLopp}
                                  
                                  
                                    </tbody>
                                </table> 
                            </div>
                        </div>
                        
                        <div className="uk-grid">
                            <div className="uk-width-1-1  btn-right-align">
                                <Link to={backUrl} className="md-btn md-btn-small md-btn-danger md-btn-wave-light waves-effect waves-button waves-light">Cancel</Link>
                                <button type="button" onClick={this.submitForm} className="md-btn md-btn-small md-btn-primary md-btn-wave-light waves-effect waves-button waves-light">Submit</button>
                            </div>
                        </div>
                    </div>
                </div>
                { preloader && <Preloader/> }
            </div>  
        );
    }
}
 

export default AddEditAction;


// WEBPACK FOOTER //
// ./src/components/Setting/Roles/addEdit.js